import { Image } from 'src/components/atoms/Image'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { Certification } from 'src/server/router/certifications/types'

interface Props {
  certificationData: Certification[]
}

const CertificationBadge = ({ data }: { data: Certification }) => {
  return (
    <div className='p-1 md:w-1/2'>
      <Image width='150' height='150' src={data.Image} alt={data.Description} />
    </div>
  )
}

export const FunderCertifications = ({ certificationData }: Props) => {
  const certifications = certificationData.filter(c => c.Awarded) || []
  if (!certifications.length) {
    // non-essential info. Simply hide it if data is missing or irrelevant
    return null
  }

  return (
    <div className='flex flex-col items-center py-5 border-y-2'>
      <div className='pb-4'>
        <TypographyRebrand variant='eyebrow' color='forestDeep'>
          Certifications
        </TypographyRebrand>
      </div>
      <div className='flex flex-wrap justify-center w-3/5 md:w-4/5'>
        {certifications.map((data, idx) => {
          return <CertificationBadge data={data} key={idx} />
        })}
      </div>
    </div>
  )
}
